import { graphql, useStaticQuery } from "gatsby";
import React from "react";
import Technology from "../../components/technologies/technology";
import TechnologySlide from "../../components/technologies/technology-slide";

const Tech: React.FC = () => {
  const data = useStaticQuery(graphql`
    {
      react: file(relativePath: { eq: "icons/react.png" }) {
        publicURL
      }
      flutter: file(relativePath: { eq: "icons/flutter.png" }) {
        publicURL
      }
      node: file(relativePath: { eq: "icons/nodejs.png" }) {
        publicURL
      }
      graphql: file(relativePath: { eq: "icons/graphql.png" }) {
        publicURL
      }
    }
  `);

  return (
    <>
      <div id="technologies" className="p-5 pt-10">
        <div className="grid grid-cols-7 pb-10">
          <hr className="col-span-1 content-center mt-10 border-gray-400"></hr>
          <div className="md:pl-3 col-span-6 col-start-2 text-4xl ">
            <div className="text-4xl">
              Current stack{" "}
              <small className="pl-1 -mt-2 md:-mt-8 block sm:inline text-xs">
                My current go-to technologies
              </small>
            </div>
          </div>
        </div>
        <div
          style={{
            justifyItems: "center",
          }}
          className="grid grid-cols-1 lg:grid-cols-4  justify-center md:grid-cols-2 lg:p-5"
        >
          <Technology
            category="web"
            logo={`${data.react?.publicURL}`}
            name="ReactJS"
          />

          <Technology
            category="mobile"
            logo={`${data.flutter?.publicURL}`}
            name="Flutter"
          />
          <Technology
            category="server"
            logo={`${data.node?.publicURL}`}
            name="NodeJS"
          />
          <Technology
            category="api"
            logo={`${data.graphql?.publicURL}`}
            name="GraphQL"
          />
        </div>
      </div>
      <div id="technologies" className="p-5 pt-10">
        <div className="grid grid-cols-7 pb-10">
          <hr className="col-span-1 content-center mt-10 border-gray-400"></hr>
          <div className="md:pl-3 col-span-6 col-start-2 text-4xl ">
            <div className="text-4xl">
              Familiar with{" "}
              <small className="pl-1 -mt-2 md:-mt-8  block sm:inline text-xs">
                Things(languages/ framework/ tools/ packages) worked on.
              </small>
            </div>
          </div>
        </div>
        <div className="pt-2">
          <TechnologySlide />
        </div>
      </div>
    </>
  );
};

export default Tech;
